import React from 'react';
import { ArrowRight, Server, Cloud, Terminal } from 'lucide-react';

const Hero: React.FC = () => {
  return (
    <section className="relative min-h-screen bg-gradient-to-b from-slate-950 to-slate-900 flex items-center">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-blue-900/20 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-slate-950 to-transparent"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 py-20 pt-32 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div className="inline-block px-3 py-1 bg-slate-800/60 backdrop-blur-sm rounded-full text-teal-400 font-medium text-sm">
              Tech Solutions for Modern Businesses
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Powering Your <span className="text-gradient bg-gradient-to-r from-teal-400 to-blue-500">Digital Infrastructure</span>
            </h1>
            
            <p className="text-lg text-slate-300 max-w-xl">
              PStechlab provides enterprise-grade web hosting, cloud solutions, and DevOps expertise to help your business thrive in the digital landscape.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a 
                href="#services" 
                className="px-6 py-3 rounded-md bg-teal-500 hover:bg-teal-600 text-white font-medium transition-all duration-300 hover:shadow-lg hover:shadow-teal-500/20 flex items-center gap-2"
              >
                Explore Services
                <ArrowRight className="w-4 h-4" />
              </a>
              <a 
                href="#contact" 
                className="px-6 py-3 rounded-md bg-slate-800 hover:bg-slate-700 text-white font-medium transition-all duration-300 border border-slate-700 hover:border-slate-600"
              >
                Contact Us
              </a>
            </div>

            <div className="flex items-center gap-4 pt-4">
              <div className="flex -space-x-2">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="w-8 h-8 rounded-full bg-gradient-to-br from-slate-400 to-slate-600 border-2 border-slate-900"></div>
                ))}
              </div>
              <p className="text-sm text-slate-400">Trusted by 200+ businesses</p>
            </div>
          </div>
          
          <div className="relative flex justify-center">
            <div className="relative w-full max-w-md aspect-square bg-slate-800/30 backdrop-blur-sm rounded-2xl p-8 border border-slate-700/50 shadow-xl">
              <div className="absolute -top-4 -left-4 w-16 h-16 bg-blue-500/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                <Server className="w-8 h-8 text-blue-400" />
              </div>
              <div className="absolute top-1/4 -right-4 w-16 h-16 bg-teal-500/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                <Cloud className="w-8 h-8 text-teal-400" />
              </div>
              <div className="absolute -bottom-4 left-1/3 w-16 h-16 bg-purple-500/20 backdrop-blur-sm rounded-xl flex items-center justify-center">
                <Terminal className="w-8 h-8 text-purple-400" />
              </div>
              
              <div className="h-full rounded-lg border border-slate-700/50 bg-slate-900/50 backdrop-blur-sm p-4 flex flex-col justify-between">
                <div className="space-y-4">
                  <div className="h-2 w-3/4 bg-slate-700 rounded"></div>
                  <div className="h-2 w-1/2 bg-slate-700 rounded"></div>
                  <div className="h-2 w-5/6 bg-slate-700 rounded"></div>
                </div>
                
                <div className="mt-4 grid grid-cols-2 gap-2">
                  {[...Array(6)].map((_, i) => (
                    <div key={i} className="h-16 bg-slate-800/80 rounded-md p-2 flex flex-col justify-between">
                      <div className="h-2 w-1/2 bg-slate-700 rounded"></div>
                      <div className="h-2 w-3/4 bg-slate-700 rounded"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            <div className="absolute -z-10 w-full h-full bg-gradient-to-r from-blue-500/10 to-teal-500/10 blur-3xl rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;